<template>
  <v-select
    v-model="model"
    :placeholder="placeholder"
    :options="apiData"
    :loading="loading"
    :multiple="multiple"
    label="name"
    :filterBy="myFilter"
    @input="updateParent"
    :reduce="name => name.code"
  >
    <template v-slot:option="item">
      {{ `${item.code} - ${item.name}` }}
    </template>
    <template v-slot:options="item">
      {{ `${item.code} - ${item.name}` }}
    </template>
    <template v-slot:no-options="{ search, loading }">
      <template v-if="apiData.length === 0">
        No se encontraron resultados <em>{{ search }}</em>.
      </template>
      <em v-if="loading" style="opacity: 0.5">Cargando...</em>
    </template>
    <template #selected-option="{ code, name }">
      {{ `${code} - ${name}` }}
    </template>
    <template #spinner="{ loading }">
      <div
        v-if="loading"
        style="border-left-color: rgba(88, 151, 251, 0.71)"
        class="vs__spinner"
      >
      </div>
    </template>
  </v-select>
</template>

<script>
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';

  export default {
    middleware: 'auth',
    components: {
      vSelect,
    },
    props: {
      api: {
        type: String,
        required: true,
        default: '',
      },
      multiple: {
        type: Boolean,
        required: true,
        default: false,
      },
      placeholder: {
        type: String,
        required: true,
        default: '',
      },
      selected: {
        required: true,
        default: [],
      },
    },
    data: () => ({
      apiData: [],
      loading: true,
      myFilter: (option, label, search) => {
        const temp = search.toLowerCase();
        return option.name.toString().toLowerCase().indexOf(temp) > -1 || option.code.toString().toLowerCase().indexOf(temp) > -1;
      },
      model: [],
    }),
    async created() {
      await this.searchAll();
      this.apiData = JSON.parse(localStorage.getItem('activities'));
      this.loading = false;
    },
    watch: {
      selected: {
        handler() {
          this.model = this.selected;
        },
        deep: true,
      },
    },
    methods: {
      searchAll() {
        this.loading = true;
        window.axios.get(this.api)
          .then((response) => {
            this.apiData = response.data;
            localStorage.setItem('activities', JSON.stringify(response.data));
            this.loading = false;
            if (this.apiData.length === 0) {
              this.apiData = [];
              this.searching = true;
            }
            this.model = this.selected;
          });
      },
      updateParent(value) {
        this.$emit('eventupdate', value);
      },
    },
  };
</script>
<style>
  .vs__dropdown-toggle{
    border: none;
    border-radius: 0px;
    border-bottom: solid 1px rgba(0,0,0,0.40);
  }
  .vs__search::placeholder{
    color: rgba(0,0,0,0.60);
  }
  .v-select.vs--single{
    margin-top: 15px;
  }
  .vs__selected{
    background-color: #1e88e5;
    color: white;
  }
  .vs__dropdown-option{
    min-height: 30px;
  }
</style>
